import { useState } from "react";

export const useTableHandlers = (initialState: {
  order?: "asc" | "desc";
  sort?: string;
  page?: number;
  rowsPerPage?: number;
  rows?: number;
}) => {
  const [order, setOrder] = useState<"asc" | "desc">(initialState.order || "asc");
  const [sort, setSort] = useState<string>(initialState.sort || "status");
  const [page, setPage] = useState<number>(initialState.page || 0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(initialState.rowsPerPage || 100);
  const [rows, setRows] = useState<number>(initialState.rowsPerPage || 0);

  const changeSort = (newSort: string) => {
    setPage(0);
    setSort(newSort);
  };

  const changeOrder = (newOrder: "asc" | "desc") => {
    setPage(0);
    setOrder(newOrder);
  };

  const handleRowsPerPageChange = (newValue: number) => {
    setRowsPerPage(newValue);
    setPage(0);
  };

  return {
    order,
    sort,
    page,
    rowsPerPage,
    rows,
    changeSort,
    changeOrder,
    handleRowsPerPageChange,
    setPage,
    setOrder,
    setSort,
    setRowsPerPage,
    setRows
  };
};